<template>
  <div class="about col offset-lg-1 col-lg-10">

    <div class="row">
      <div class="col-lg-12">
        <h2 class="about-header landed">How to Cast media Art?</h2>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="about-short">

            <div class="row">
              <div class="col-lg-12">
                <p class="instructions-header sub-header">Casting requirements:</p>
              </div>
            </div>

            <div class="row">
              <div class="offset-lg-1 col-lg-10">
                <p class="object-list">- Ethereum address</p>
                <p class="object-list">- Web3 provider like Metamask or a wallet with smart contract browser</p>
                <p class="object-list">- Some ether</p>
                <p class="object-list">- File with the artwork</p>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12">
                <p class="instructions-header sub-header">Casting instructions:</p>
              </div>
            </div>

            <div class="row">
              <div class="offset-lg-1 col-lg-10">
                <p>In 2018 we recomend using <a href="https://metamask.io/">Metamask</a>. It is a browser extension that allows you to interact with Ethereum Smart Contracts right in your browser without running a full Ethereum node. You can install the Metamask add-on in Chrome, Firefox, Opera, and other desktop browsers.</p>
              </div>
            </div>

            <div class="row">
              <div class="offset-lg-1 col-lg-10">
                <p>When registering a new Metamask wallet be sure to <u>back up your mnemonic phrase</u>. You will use it to restore access to your wallet in case something hapens to the computer you use at the moment. You will need the exact same wallet that you use for casting to transfer ownership of the artwork in case you sell it or give it to a someone.</p>
              </div>
            </div>

            <div class="row">
              <div class="offset-lg-1 col-lg-10">
                <p>With Metamask the casting process is pretty straight forward. You can do everything on this web-site. Just <a href="/">go to the cast page</a> and the interface will guide you through the process.</p>
              </div>
            </div>

            <div class="row gif">
              <div class="col-lg-10">
                  <img class="gif-manual" src="../assets/gifs/cast.gif">
              </div>
            </div>

            <div class="row">
              <div class="offset-lg-1 col-lg-10">
                <p>The casting procedure itself is an Ethereum blockchain transaction that is being sent to the contract address. Once the transaction is approved by the network - you are done with casting and the Ethereum address that you have used will be recorded as the cast creator and first owner. <b>Congratulations!</b></p>
              </div>
            </div>

            <div class="row gif">
              <div class="col-lg-10">
                  <img class="gif-manual" src="../assets/gifs/check_your_cast.gif">
              </div>
            </div>

            
            <div class="row">
              <div class="offset-lg-1 col-lg-10">
                <p>There is a demo version of castart at <a href="https://test.castart.net/">test.castart.net</a> if you need to test the functionality without spending real ethers.</p>
              </div>
            </div>

            <div class="row">
              <div class="offset-lg-1 col-lg-10">
                <p>If you want to use an Ethereum wallet with a smart contract browser instead of Metamask browser plugin - you will need the smart contract ABI so that your wallet knows what smart contract endpoints you can interact with. The contract address on the <i>Main Ethereum network</i> is <b>0xd8a5bb8da68b3e5846807258b34010a9616b0731</b> and this is the CastArt smart contract ABI JSON:</p>
              </div>
            </div>


            <div class="row code">
              <div class="offset-lg-1 col-lg-10">
                <!-- Highlighted ABI JSON start -->
                <pre id="json">
                <span class="pun"> </span>
                <span class="pun">[</span>
                  <span class="pun">{</span>
                    <span class="typ">"constant"</span> <span class="pun">:</span> <span class="lit">false</span> <span class="pun">,</span>
                    <span class="typ">"inputs"</span> <span class="pun">:</span> <span class="pun">[</span>
                      <span class="pun">{</span> <span class="com">"name"</span> <span class="pun">:</span> <span class="str">"_hash_key"</span><span class="pun">,</span> <span class="kwd">"type"</span> <span class="pun">:</span> <span class="str">"bytes"</span> <span class="pun">},</span>
                      <span class="pun">{</span> <span class="com">"name"</span> <span class="pun">:</span> <span class="str">"_description"</span><span class="pun">,</span> <span class="kwd">"type"</span> <span class="pun">:</span> <span class="str">"string"</span> <span class="pun">}</span>
                    <span class="pun">]</span><span class="pun">,</span>
                    <span class="com">"name"</span> <span class="pun">:</span> <span class="str">"updateCastDescription"</span><span class="pun">,</span>
                    <span class="typ">"outputs"</span> <span class="pun">:</span> <span class="pun">[</span>
                      <span class="pun">{</span> <span class="com">"name"</span> <span class="pun">:</span> <span class="str">"success"</span><span class="pun">,</span> <span class="kwd">"type"</span> <span class="pun">:</span> <span class="str">"bool"</span> <span class="pun">}</span>
                    <span class="pun">],</span>
                    <span class="typ">"payable"</span> <span class="pun">:</span> <span class="lit">false</span><span class="pun">,</span>
                    <span class="typ">"stateMutability"</span> <span class="pun">:</span> <span class="str">"nonpayable"</span><span class="pun">,</span> <span class="kwd">"type"</span> <span class="pun">:</span> <span class="str">"function"</span>
                  <span class="pun">},</span>
                  <span class="pun">{</span>
                    <span class="typ">"constant"</span> <span class="pun">:</span> <span class="lit">true</span><span class="pun">,</span>
                    <span class="typ">"inputs"</span> <span class="pun">: [ ],</span>
                    <span class="com">"name"</span> <span class="pun">:</span> <span class="str">"Greet"</span><span class="pun">,</span>
                    <span class="typ">"outputs"</span> <span class="pun">:</span> <span class="pun">[</span>
                      <span class="pun">{</span> <span class="com">"name"</span> <span class="pun">:</span> <span class="str">"greet_info"</span><span class="pun">,</span> <span class="kwd">"type"</span> <span class="pun">:</span> <span class="str">"string"</span><span class="pun">}</span>
                    <span class="pun">]</span><span class="pun">,</span>
                    <span class="typ">"payable"</span> <span class="pun">:</span> <span class="lit">false</span><span class="pun">,</span>
                    <span class="typ">"stateMutability"</span> <span class="pun">:</span> <span class="str">"view"</span><span class="pun">,</span> <span class="kwd">"type"</span> <span class="pun">:</span> <span class="str">"function"</span>
                  <span class="pun">},</span>
                  <span class="pun">{</span>
                    <span class="typ">"constant"</span> <span class="pun">:</span> <span class="lit">true</span><span class="pun">,</span>
                    <span class="typ">"inputs"</span> <span class="pun">:</span> <span class="pun">[</span>
                      <span class="pun">{</span> <span class="com">"name"</span> <span class="pun">:</span> <span class="str">"_hash_key"</span><span class="pun">,</span> <span class="kwd">"type"</span> <span class="pun">:</span> <span class="str">"bytes"</span> <span class="pun">}</span>
                    <span class="pun">],</span>
                    <span class="com">"name"</span> <span class="pun">:</span> <span class="str">"getCast"</span><span class="pun">,</span>
                    <span class="typ">"outputs"</span> <span class="pun">:</span> <span class="pun">[</span>
                      <span class="pun">{</span> <span class="com">"name"</span> <span class="pun">:</span> <span class="str">"_cast_creator"</span><span class="pun">,</span> <span class="kwd">"type"</span> <span class="pun">:</span> <span class="str">"address"</span> <span class="pun">},</span>
                      <span class="pun">{</span> <span class="com">"name"</span> <span class="pun">:</span> <span class="str">"_cast_owner"</span><span class="pun">,</span> <span class="kwd">"type"</span> <span class="pun">:</span> <span class="str">"address"</span> <span class="pun">},</span>
                      <span class="pun">{</span> <span class="com">"name"</span> <span class="pun">:</span> <span class="str">"_file_hash"</span><span class="pun">,</span> <span class="kwd">"type"</span> <span class="pun">:</span> <span class="str">"string"</span> <span class="pun">},</span>
                      <span class="pun">{</span> <span class="com">"name"</span> <span class="pun">:</span> <span class="str">"_description"</span><span class="pun">,</span> <span class="kwd">"type"</span> <span class="pun">:</span> <span class="str">"string"</span> <span class="pun">}</span>
                    <span class="pun">],</span>
                    <span class="typ">"payable"</span> <span class="pun">:</span> <span class="lit">false</span><span class="pun">,</span>
                    <span class="typ">"stateMutability"</span> <span class="pun">:</span> <span class="str">"view"</span><span class="pun">,</span> <span class="kwd">"type"</span> <span class="pun">:</span> <span class="str">"function"</span>
                  <span class="pun">},</span>
                  <span class="pun">{</span>
                    <span class="typ">"constant"</span> <span class="pun">:</span> <span class="lit">false</span><span class="pun">,</span>
                    <span class="typ">"inputs"</span> <span class="pun">:</span> <span class="pun">[</span>
                      <span class="pun">{</span> <span class="com">"name"</span> <span class="pun">:</span> <span class="str">"_hash_key"</span><span class="pun">,</span> <span class="kwd">"type"</span> <span class="pun">:</span> <span class="str">"bytes"</span> <span class="pun">},</span>
                      <span class="pun">{</span> <span class="com">"name"</span> <span class="pun">:</span> <span class="str">"newOwner"</span><span class="pun">,</span> <span class="kwd">"type"</span> <span class="pun">:</span> <span class="str">"address"</span> <span class="pun">}</span>
                    <span class="pun">],</span>
                    <span class="com">"name"</span> <span class="pun">:</span> <span class="str">"transferCastOwnership"</span><span class="pun">,</span>
                    <span class="typ">"outputs"</span> <span class="pun">:</span> <span class="pun">[</span>
                      <span class="pun">{</span> <span class="com">"name"</span> <span class="pun">:</span> <span class="str">"success"</span><span class="pun">,</span> <span class="kwd">"type"</span> <span class="pun">:</span> <span class="str">"bool"</span><span class="pun">}</span>
                    <span class="pun">],</span>
                    <span class="typ">"payable"</span> <span class="pun">:</span> <span class="lit">false</span><span class="pun">,</span>
                    <span class="typ">"stateMutability"</span> <span class="pun">:</span> <span class="str">"nonpayable"</span><span class="pun">,</span> <span class="kwd">"type"</span> <span class="pun">:</span> <span class="str">"function"</span>
                  <span class="pun">},</span>
                  <span class="pun">{</span>
                    <span class="typ">"constant"</span> <span class="pun">:</span> <span class="lit">false</span><span class="pun">,</span>
                    <span class="typ">"inputs"</span> <span class="pun">:</span> <span class="pun">[</span>
                    <span class="pun">]</span><span class="pun">,</span>
                    <span class="com">"name"</span> <span class="pun">:</span> <span class="str">"Donate"</span><span class="pun">,</span>
                    <span class="typ">"outputs"</span> <span class="pun">:</span> <span class="pun">[</span>
                      <span class="pun">{</span> <span class="com">"name"</span> <span class="pun">:</span> <span class="str">"success"</span><span class="pun">,</span> <span class="kwd">"type"</span> <span class="pun">:</span> <span class="str">"bool"</span> <span class="pun">}</span>
                    <span class="pun">],</span>
                    <span class="typ">"payable"</span> <span class="pun">:</span> <span class="lit">true</span><span class="pun">,</span>
                    <span class="typ">"stateMutability"</span> <span class="pun">:</span> <span class="typ">"payable"</span><span class="pun">,</span> <span class="kwd">"type"</span> <span class="pun">:</span> <span class="str">"function"</span>
                  <span class="pun">},</span>
                  <span class="pun">{</span>
                    <span class="typ">"constant"</span> <span class="pun">:</span> <span class="lit">false</span><span class="pun">,</span>
                    <span class="typ">"inputs"</span> <span class="pun">:</span> <span class="pun">[</span>
                      <span class="pun">{</span> <span class="com">"name"</span> <span class="pun">:</span> <span class="str">"_file_hash"</span><span class="pun">,</span> <span class="kwd">"type"</span> <span class="pun">:</span> <span class="str">"bytes"</span> <span class="pun">},</span>
                      <span class="pun">{</span> <span class="com">"name"</span> <span class="pun">:</span> <span class="str">"_description"</span><span class="pun">,</span> <span class="kwd">"type"</span> <span class="pun">:</span> <span class="str">"string"</span> <span class="pun">}</span>
                    <span class="pun">],</span>
                    <span class="com">"name"</span> <span class="pun">:</span> <span class="str">"castMedia"</span><span class="pun">,</span>
                    <span class="typ">"outputs"</span> <span class="pun">:</span> <span class="pun">[</span>
                      <span class="pun">{</span> <span class="com">"name"</span> <span class="pun">:</span> <span class="str">"success"</span><span class="pun">,</span> <span class="kwd">"type"</span> <span class="pun">:</span> <span class="str">"bool"</span> <span class="pun">}</span>
                    <span class="pun">]</span><span class="pun">,</span>
                    <span class="typ">"payable"</span> <span class="pun">:</span> <span class="lit">false</span><span class="pun">,</span>
                    <span class="typ">"stateMutability"</span> <span class="pun">:</span> <span class="str">"nonpayable"</span><span class="pun">,</span> <span class="kwd">"type"</span> <span class="pun">:</span> <span class="str">"function"</span>
                  <span class="pun">}</span>
                <span class="pun">]</span>
              </pre>
              <!-- Highlighted ABI JSON end -->
            </div>
          </div>


          <div class="row">
            <div class="offset-lg-1 col-lg-10">
              <p>When calling contract functions from your wallet you will need to digest the SHA256 from your file yourself. This can be done in various ways. You can simply use the command line, or you can use all the web-sites that calculate the cryptografic hash functions for you.
                When you cast art using your wallet - pay attention to the data that you are submiting. <b><u>Submition of incorrect data will burn your Ethers.</u></b></p>
            </div>
          </div>


        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <h2 class="about-header landed">Using other functions</h2>
      </div>
    </div>


    <div class="row">
      <div class="col-lg-12">
        <div class="about-short">
          <p>

          <div class="row">
            <div class="col-lg-12">
              <p class="instructions-header sub-header">The two other functions of the smart contract are:</p>
            </div>
          </div>


          <div class="row">
            <div class="offset-lg-1 col-lg-10">
              <p class="object-list">- Updating the description of an existing cast</p>
              <p class="object-list">- Transferring ownership of a cast</p>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-12">
              <p class="instructions-header sub-header">How to update a description of an existing cast?</p>
            </div>
          </div>

          <div class="row">
            <div class="offset-lg-1 col-lg-10">
              <p>If you are using Metamask it is pretty simple. You need to <a href="/check">go to the cast lookup page</a> and follow the interface will guide you through the process.</p>
            </div>
          </div>


          <div class="row gif">
            <div class="col-lg-10">
                <img class="gif-manual" src="../assets/gifs/update_your_cast_description.gif">
            </div>
          </div>

          <div class="row">
            <div class="offset-lg-1 col-lg-10">
              <p>You need to input the SHA256 of the cast you would like to edit, look it up and provide a new description. The web-page will prepare a transaction for you to execute the descrition change.</p>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-12">
              <p class="instructions-header sub-header">How to transfer ownership of an existing cast?</p>
            </div>
          </div>

          <div class="row">
            <div class="offset-lg-1 col-lg-10">
              <p>If you are using Metamask - the procedure is the same like updating a description of an existing cast. You need to <a href="/check">go to the cast lookup page</a> and follow the interface will guide you through the process.</p>
            </div>
          </div>

          <div class="row">
            <div class="offset-lg-1 col-lg-10">
              <p>You need to input the SHA256 of the cast you would like to transfer ownership, look it up and provide new owners ethereum address. The web-page will prepare a transaction for you to execute the ownership transfer.</p>
            </div>
          </div>

          <div class="row gif">
            <div class="col-lg-10">
                <img class="gif-manual" src="../assets/gifs/transfer_cast_ownership.gif">
            </div>
          </div>

          <div class="row">
            <div class="offset-lg-1 col-lg-10">
              <p>After this action only the new owner will be able to change the cast description and transfer the cast ownership.</p>
            </div>
          </div>
          
          <div class="row gif">
            <div class="col-lg-10">
                <img class="gif-manual" src="../assets/gifs/check_public_cast.gif">
            </div>
          </div>

          <div class="row">
            <div class="offset-lg-1 col-lg-10">
              <p><b><u><span class="text-danger">WARNING!!!</span> TRIPLE-CHECK THE ADDRESS OF THE NEW OWNER! SUBMITION OF INCORRECT ETHEREUM ADDRESS OF THE NEW OWNER WILL BURN DOWN YOUR CAST and the Ether. THERE IS ABSOLUTELY NO WAY TO UNDO BLOCKCHAIN TRANSACTIONS!</u></b></p>
            </div>
          </div>

        </div>
      </div>
    </div>



</div>
</template>

<script>
export default {
  name: 'HowTo',
  data () {
    return {
      msg: 'How To'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/HowTo.vue